import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const mediaUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("aic_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
